var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
    This file is generated with the "identicons" script.
    To update this output make changes to `scripts/svgr/identicon-icon-template.js
    */
import * as React from 'react';
import { IdenticonsCustomProperty, useColorMap, identiconComponentName } from '../common';
import { styled } from '../../styled';
export var IdenticonAuth0Dashboard = styled(function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    var colorMap = useColorMap({
        color: color,
    });
    var fills = {
        light: "var(".concat(IdenticonsCustomProperty.light, ", ").concat(colorMap.light, ")"),
        base: "var(".concat(IdenticonsCustomProperty.base, ", ").concat(colorMap.base, ")"),
        dark: "var(".concat(IdenticonsCustomProperty.dark, ", ").concat(colorMap.dark, ")"),
    };
    return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M39.998 40.026H19.97V8h20.027A4.002 4.002 0 0144 12.002v24.022a4.002 4.002 0 01-4.002 4.002z", fill: fills.light }),
        React.createElement("path", { d: "M27.585 23.204c2.01-.332 3.586-1.996 3.916-4.009l.11-.968c.028-.153-.076-.367-.27-.352-1.52.119-2.952.62-3.75.947a1.053 1.053 0 00-.653.975v3.156c0 .187.168.33.352.3l.295-.048v-.001zM32.47 19.195c.331 2.013 1.907 3.677 3.916 4.009l.295.048a.303.303 0 00.352-.3v-3.156c0-.428-.258-.813-.654-.975-.798-.328-2.23-.828-3.749-.947-.195-.015-.295.2-.272.353l.111.967.001.001zM36.384 24.088c-2.747.543-4.022 2.371-4.022 5.833 0 .174.172.294.317.198 1.263-.854 4.043-3.08 4.329-5.867.011-.35-.427-.186-.624-.164zM27.586 24.088c2.747.543 4.022 2.371 4.022 5.833 0 .174-.172.294-.317.198-1.263-.854-4.043-3.08-4.329-5.867-.01-.35.427-.186.624-.164zM8.002 40.026h11.99V8H8.002A4.002 4.002 0 004 12.002v24.022a4.002 4.002 0 004.002 4.002z", fill: fills.dark }),
        React.createElement("path", { d: "M9.151 14.152a1.144 1.144 0 100-2.289 1.144 1.144 0 000 2.289z", fill: fills.light }),
        React.createElement("path", { d: "M13.097 20.016H8.996a.986.986 0 110-1.973h4.1a.986.986 0 110 1.973zM13.097 28.032H8.996a.986.986 0 110-1.973h4.1a.986.986 0 110 1.973zM15.09 24.023H8.997a.986.986 0 110-1.973h6.095a.986.986 0 110 1.973z", fill: fills.base }),
        React.createElement("path", { d: "M10.992 36.029H8.996a.986.986 0 110-1.973h1.996a.986.986 0 110 1.973z", fill: fills.light })));
}, {
    name: identiconComponentName,
})({});
